<template>
  <a-modal
    v-model="visible"
    cancelText="退出向导"
    width="1024px"
    :closable="false"
    :maskClosable="false"
    :footer="null">
<!--    <template #closeIcon>-->
<!--      <a-tooltip placement="top">-->
<!--        <template slot="title">-->
<!--          <span>最小化</span>-->
<!--        </template>-->
<!--        <a-icon type="minus-circle" class="mr-2" theme="twoTone" two-tone-color="#52c41a" />-->
<!--      </a-tooltip>-->
<!--      <a-tooltip placement="top">-->
<!--        <template slot="title">-->
<!--          <span>退出向导</span>-->
<!--        </template>-->
<!--        <a-icon type="close-circle" class="mr-2" theme="twoTone" two-tone-color="#eb2f96" />-->
<!--      </a-tooltip>-->
<!--    </template>-->
    <a-row type="flex" style="padding-top: 24px;padding-bottom: 24px">
      <a-col flex="4" style="padding-left: 24px;">
        <img :src="logo" style="width: 128px;" />
        <h1 style="margin-top: 24px;">欢迎使用云联壹云</h1>
        <h1>本向导将辅助您完成首次配置</h1>
        <div style="margin-left: 0.5em; margin-top: 1em;">
          <p style="margin-bottom: 0px; margin-top: 24px;">如果您在使用过程中遇到任何问题，欢迎加入云联壹云社区</p>
          <ul style="padding-left: 20px;">
            <li>问题解答</li>
            <li>技术分享</li>
            <li>社区交流</li>
          </ul>
        </div>
        <a-button size="large" shape="round" class="guide-start-btn" @click="showGuide">
          开始配置<a-icon type="right-circle" />
        </a-button>
      </a-col>
      <a-col flex="2">
        <div class="text-center" style="margin-top: 80px;">
          <img src="../../../layouts/Navbar/wechat_qrcode.png"  alt="WeChat QRCode" />
          <p>微信扫码加入社区</p>
        </div>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
// todo: 只能在管理后台和域管理后台弹出菜单
// todo: 已经登录的用户 点击 saas免费开通应该自动跳转到控制台
// todo: 批量为用户设置为正式用户
// todo: 申请协助 关键密钥密码信息脱敏
export default {
  name: 'WelcomeScreen',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      visible: true,
    }
  },
  computed: {
    ...mapGetters([
      'logo',
    ]),
    ...mapGetters('app', ['user_guide']),
  },
  methods: {
    async onCloseWelcomeScreen () {
      await this.$store.dispatch('app/nextUserGuide')
    },
    async showGuide () {
      this.visible = false
      await this.onCloseWelcomeScreen()
      this.createDialog('CloudAccountSetupGuideDialog', this.params)
    },
  },
}
</script>

<style lang="less" scoped>
.guide-start-btn {
  float: right;
  color: #fff;
  background: #076f38 linear-gradient(
    180deg
    ,#2c8556,#076f38)repeat-x;
  border-color: #076f38;
  box-shadow: inset 0 1px rgb(255 255 255/15%), 0 1px 1px rgb(0 0 0/8%);
}
</style>
